// Tour utility functions and constants

// Brand constants
export const BRAND = {
  name: "Tour in a Box",
  primary: "#B35C3F",
  accent: "#38B6FF",
  text: "#000000",
  logoUrl:
    "https://images.squarespace-cdn.com/content/v1/681e880338e127740df56b8d/55ec7966-4563-4cc0-ba95-ffaf1064e9d0/Yellow+and+Green+Accessories+Business+Label+Circle+Sticker-2.png",
};

// Secret phrase constants
export const SECRET_PHRASE = "SEARCH THE BOX";
export const SECRET_LETTERS = SECRET_PHRASE.replace(/\s/g, "").split("");

export const SECRET_INDEX_BY_STEP = {
  "step-1": 6,  // SEAHORSE
  "step-2": 3,  // NAVE
  "step-3": 2,  // STAR
  "step-4": 3,  // PEARL
  "step-5": 0,  // CUBA
  "step-6": 4,  // FIFTH
  "step-7": 4,  // LIGHTHOUSE
  "step-8": 4,  // TORCHES
  "step-9": 3,  // POPE
  "step-10": 0, // BAPTIST
  "step-11": 1, // ROOTS
  "step-12": 0, // X
};

// LocalStorage key generators
export const storageKey = (slug) => `tib_progress_${slug}`;
export const finishedKey = (slug) => `tib_finished_${slug}`;

// String normalization for answer comparison
export const normalize = (s) => (s || "").toString().trim().toLowerCase().replace(/[^a-z0-9]/g, "");

// Extract difficulty level from meta string
export function difficultyFromMeta(meta = "") {
  const m = (meta || "").toLowerCase();
  if (m.includes("hard")) return { level: 3, label: "Hard" };
  if (m.includes("medium")) return { level: 2, label: "Medium" };
  return { level: 1, label: "Easy" };
}

// Helper for generating Google Maps URLs
export function toMapsUrl(name, address) {
  const q = encodeURIComponent(`${name || ""} ${address || ""}`.trim());
  return `https://maps.google.com/?q=${q}`;
}
